import { DocumentFileIcon, StyledTooltip, Typography, VideoIcon } from '@room-match/shared-ui-components';
import React, { useState } from 'react';
import ImageGallery from 'shared/components/ImageGallery/ImageGallery';
import useWindowDimensions from 'shared/hooks/useWindowDimenstion';
import { IMediumAttributes } from 'shared/interfaces/IMedium';
import AudioItem from './AudioItem';
import { FileItem, ImageContainer, MediaItem, PlainHeading, ScrollableContainer, useStyles } from './RefFiles.styles';
import LinkItem from '../LinkItem/LinkItem';
import { Tooltip } from '@material-ui/core';

interface Props {
  audio: IMediumAttributes[];
  videos: IMediumAttributes[];
  docs: IMediumAttributes[];
  photos: IMediumAttributes[];
  links: string[];
}

const RefFiles: React.FC<Props> = ({ audio, videos, docs, photos, links }) => {
  const classes = useStyles();
  const [imageIndex, setimageIndex] = useState<number>(0);
  const [showImageModal, setshowImageModal] = useState<boolean>(false);

  console.log({ links });

  const { width } = useWindowDimensions();

  const renderPhotos = () => {
    if (photos) {
      const img = (photos as any).map((image: any, idx: number) => {
        return {
          id: image.id,
          src: image.modified_attachment || image.attachment,
          height: image.medium.file_height,
          width: image.medium.file_width,
          idx: idx + 1,
        };
      });
      return img;
    } else {
      return;
    }
  };

  const renderedImages = renderPhotos();

  const handleClick = (idx: number) => {
    setimageIndex(idx);
    setshowImageModal(true);
  };

  return (
    <div>
      <PlainHeading style={{ fontWeight: 500 }}>Reference Media/Sides:</PlainHeading>

      <>
        {(photos as any).length ? (
          <ImageContainer>
            {(photos as any).map((i: any, idx: number) => (
              <MediaItem src={i.attachment} style={{ objectFit: 'cover' }} onClick={() => handleClick(idx + 1)} />
            ))}
          </ImageContainer>
        ) : (
          <React.Fragment />
        )}

        <ScrollableContainer>
          {videos.length > 0 ? (
            videos.map((i) => (
              <Tooltip title={i.medium.file_name}>
                <FileItem onClick={() => window.open(`${i.attachment}`, '_blank')}>
                  <VideoIcon />
                  <p style={{ fontSize: 14 }}>{i.medium.file_name}</p>
                </FileItem>
              </Tooltip>
              //     <CustomVideoPlayer

              //     classes={{ root: 'profile-video-item', videoPlayer: '', icon: '' }}
              //     url={i.attachment}
              //     isSmall
              //   />
            ))
          ) : (
            <React.Fragment />
          )}
          {docs.length > 0 ? (
            docs.map((i) => (
              <Tooltip title={i.medium.file_name}>
                <FileItem onClick={() => window.open(`${i.attachment}`, '_blank')}>
                  <DocumentFileIcon />
                  <p style={{ fontSize: 14 }}>{i.medium.file_name}</p>
                </FileItem>
              </Tooltip>
            ))
          ) : (
            <React.Fragment />
          )}
          {audio.length > 0 ? audio.map((i) => <AudioItem aud={i} />) : <React.Fragment />}
          {links.length > 0 ? links.map((link, idx) => <LinkItem key={idx} url={link} />) : <React.Fragment />}
        </ScrollableContainer>
      </>
      <ImageGallery
        fullScreen={width < 960}
        current={imageIndex - 1}
        images={renderedImages}
        thumbnails={renderedImages}
        open={showImageModal}
        onClose={() => setshowImageModal(false)}
      />
    </div>
  );
};

export default RefFiles;
